import { Action, createReducer, on } from '@ngrx/store';
import { ResultsActions } from './results.actions';
import { ResultsState } from '../../shared/interfaces';

export const initialResultsState: ResultsState = {
    comparison: null,
    newSystem: null,
    currentSystem: null
};

const reducer = createReducer(
    initialResultsState,
    on(ResultsActions.calculateSystemComparisonSuccess, (state, { comparison, newSystem, currentSystem }) => ({
        ...state,
        comparison,
        newSystem,
        currentSystem
    }))
);

export function resultsReducer(state: ResultsState | undefined, action: Action) {
    return reducer(state, action);
}
